<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/support/tickets/categories', communityId)" searchable v-model:reload="reload" :orderable="[{key:'name', name: translate('name')}]">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("categories") }}</h4>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">{{ translate("color") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">{{ item.name }}</div>
                  <div class="table-column">
                    <i class="fas fa-circle fa-fw" :style="{ color: item.color }"></i>
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView v-if="authorization.permission('modules.support.tickets.categories.edit')" type="soft" color="primary" size="small" @click="editing = item">
                        <i class="fas fa-edit"></i>
                      </ButtonView>
<!--                      <ResourcePermissionModalView type="modules.support.tickets.category" :id="item.id"/>-->
                      <TargetedModalHttpFormView v-if="authorization.permission('modules.support.tickets.categories.edit')" size="small" :endpoint="utilities.path('modules/support/tickets/categories/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <h2 class="mb-4">{{ item.name }}</h2>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalHttpFormView :endpoint="creating ? utilities.path('communities/@/modules/support/tickets/categories', communityId) : utilities.path('modules/support/tickets/categories/@', editing?.id)" :method="creating ? 'post' : 'put'" :content="creating ? undefined : editing" :active="creating || editing !== undefined" @update:active="creating = false; editing = undefined" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="d-flex flex-column g-4">
          <InputView type="text" :min="1" :max="32" v-model:value="content.name" :title="translate('name')" :errors="errors.name" required/>
          <InputView type="color" v-model:value="content.color" :placeholder="translate('color')" :title="translate('color')" :errors="errors.color" required/>
          <InputView type="textarea" v-model:value="content.description" :title="translate('description')" :errors="errors.description" :max="500"/>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="submit">
              {{ translate("save") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false; editing = undefined">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </ModalHttpFormView>
  </div>
</template>

<script setup>
import {CollectionView, InputView, utilities, ButtonView, SpinnerView, ModalHttpFormView, TargetedModalHttpFormView} from "@/niftybit";
import ResourcePermissionModalView from "@/systems/modules/roles/ResourcePermissionModalView.vue";
import {ref} from "vue";
import authorization from "@/authorization";

defineProps({
  communityId: String
});

const reload = ref(false);
const creating = ref(false);
const editing = ref(undefined);

</script>